import { render, staticRenderFns } from "./MedicationAdviceParent.vue?vue&type=template&id=34c4bc3e&scoped=true"
import script from "./MedicationAdviceParent.vue?vue&type=script&lang=js"
export * from "./MedicationAdviceParent.vue?vue&type=script&lang=js"
import style0 from "./MedicationAdviceParent.vue?vue&type=style&index=0&id=34c4bc3e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c4bc3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34c4bc3e')) {
      api.createRecord('34c4bc3e', component.options)
    } else {
      api.reload('34c4bc3e', component.options)
    }
    module.hot.accept("./MedicationAdviceParent.vue?vue&type=template&id=34c4bc3e&scoped=true", function () {
      api.rerender('34c4bc3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/parentdiary/MedicationAdviceParent.vue"
export default component.exports